import { createIcon } from './icon-utils';

export const SmallXIcon = createIcon({
  path: 'M4.94 6L2.656 3.718c-.293-.293-.293-.768 0-1.061.293-.293.768-.293 1.06 0L6 4.939l2.282-2.282c.293-.293.768-.293 1.06 0 .294.293.294.768 0 1.06L7.062 6l2.282 2.282c.293.293.293.768 0 1.06-.293.293-.768.293-1.06 0L6 7.06 3.718 9.343c-.293.292-.768.292-1.06 0-.294-.293-.294-.768 0-1.061L4.938 6z',
  style: {
    height: 12,
    width: 12,
  },
  viewBox: '0 0 12 12',
});
